import { Collapse, DatePicker, Form, Input } from "antd";
import { DocumentTableFormItem } from "./document-table-form-item";
import { EmployeePermissionFormItem } from "./employee-permission-form-item";
import moment from "moment";
import { DateFormat } from "../../../../constants";
import { PublishDocumentTableFormItem } from "./publish-document-table-form-item";

export const PublishMultipleFileFormItem = ({ documentData, isPublish }: any) => {
  const defaultStartDate = moment();
  const defaultEndDate = moment().add(5, "year");

  return (
    <div className="py-2">
      <div className="d-flex column justify-content-between">
        <div className={`flex-grow-${!isPublish ? "2" : "1"}`}>
          <Collapse defaultActiveKey={["1"]} style={{ width: !isPublish ? "800px" : "100%" }}>
            <Collapse.Panel header={!isPublish ? "Danh sách tài liệu cần ban hành" : "Danh sách tài liệu cần phân phối"} key="1">
              <Form.Item
                name="documentData"
                rules={[{ required: true, message: "Vui lòng chọn tài liệu cần ban hành" }]}
              >
                {!isPublish ? (
                  <DocumentTableFormItem documentData={documentData} />
                ) : (
                  <PublishDocumentTableFormItem documentData={documentData} />
                )}
              </Form.Item>
            </Collapse.Panel>
          </Collapse>
        </div>
        {!isPublish && (
          <div className="flex-grow-1">
            <Form.Item
              name="effectiveDate"
              label={"Hiệu lực từ"}
              initialValue={[defaultStartDate, defaultEndDate]}
              rules={[{ required: true, message: "Vui lòng chọn ngày hiệu lực" }]}
            >
              <DatePicker.RangePicker
                placeholder={["Ngày hiệu lực", "Ngày hết hiệu lực"]}
                format={DateFormat.DD_MM_YYYY}
              />
            </Form.Item>
            <Form.Item name="subInfo" label={"Chủ đề"}>
              <Input.TextArea rows={1} />
            </Form.Item>
            <Form.Item name="docNotes" label={"Ghi chú"}>
              <Input.TextArea rows={4} />
            </Form.Item>
          </div>
        )}
      </div>
      <Collapse defaultActiveKey={["1"]}>
        <Collapse.Panel header="Ban hành tài liệu đến" key="1">
          <Form.Item
            name="employeeData"
            rules={[{ required: true, message: "Vui lòng chọn nhân viên cần ban hành đến" }]}
          >
            <EmployeePermissionFormItem />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};
